// extracted by mini-css-extract-plugin
module.exports = {"root":"Brand_root__MIg1-","logo":"Brand_logo__2ztmI","title":"Brand_title__2f1V1","subtitle":"Brand_subtitle__Fk7wf"};